<template>
  <section class="partners">
    <div class="partners-head">
      <div class="partners-head-inner">
        <h1>我们的合作伙伴生态系统</h1>
        <p>
          通过多元化和强大的行业领导者网络，我们为更好的全球电子商务铺平了道路，并简化了品牌和零售商的国际在线扩张
        </p>
      </div>
    </div>
    <div class="partners-tab">
      <div class="partners-tab-inner">
        <ul class="tab">
          <li
            v-for="item in tabList"
            :key="item.value"
            :class="{ action: actionTab === item.value }"
            @click="tabChange(item)"
          >
            <div class="icon">
              <img class="image" :src="item['iconUrl']" alt="" />
              <img class="image-action" :src="item['actionIconUrl']" alt="" />
            </div>
            <h3>{{ item.label }}</h3>
          </li>
        </ul>
        <div class="list">
          <div class="list-item" v-for="item in partnersList" :key="item.id">
            <a :href="item.link" target="_blank">
              <img :src="item.imageUrl" :alt="item.alt" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="partners-btn"
      v-if="actionTab != 'Payments' && actionTab != 'Agencies'"
    >
      <div class="partners-btn-inner">
        <a>合作伙伴目录</a>
      </div>
    </div>
    <div class="partners-form">
      <div class="partners-form-inner">
        <el-form
          :model="formData"
          ref="formDataRef"
          :rules="rules"
          label-width="auto"
          size="normal"
          label-position="top"
        >
          <h1>成为合作伙伴</h1>
          <el-form-item label="" prop="firstName">
            <el-input
              v-model="formData.firstName"
              placeholder="姓氏*"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="lastName">
            <el-input
              v-model="formData.lastName"
              placeholder="名字*"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="email">
            <el-input v-model="formData.email" placeholder="邮箱*"></el-input>
          </el-form-item>
          <el-form-item label="" prop="phoneNumber">
            <el-input
              v-model="formData.phoneNumber"
              placeholder="电话号码*"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="companyName">
            <el-input
              v-model="formData.companyName"
              placeholder="公司名称*"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="companyWebsite">
            <el-input
              v-model="formData.companyWebsite"
              placeholder="公司网站*"
            ></el-input>
          </el-form-item>
          <el-form-item label="国家" prop="country">
            <el-select
              v-model="formData.country"
              placeholder="请选择"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in countryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合作伙伴类型" prop="partnerType">
            <el-select
              v-model="formData.partnerType"
              placeholder="请选择"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in partnerTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="logo">
            <div class="logo-inner">
              <iframe
                title="reCAPTCHA"
                width="256"
                height="60"
                role="presentation"
                name="a-zhsdlsowmpcj"
                frameborder="0"
                scrolling="no"
                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"
                src="https://www.recaptcha.net/recaptcha/enterprise/anchor?ar=1&amp;k=6Ld_ad8ZAAAAAAqr0ePo1dUfAi0m4KPkCMQYwPPm&amp;co=aHR0cHM6Ly93d3cuZ2xvYmFsLWUuY29tOjQ0Mw..&amp;hl=en&amp;v=rW64dpMGAGrjU7JJQr9xxPl8&amp;size=invisible&amp;badge=inline&amp;cb=olmon4aoo0bn"
              ></iframe>
            </div>
          </div>
          <el-form-item>
            <a class="btn" @click="onSubmit">提 交</a>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </section>
</template>

<script>
import country from '@/data/country.json'
import partnerType from '@/data/partnerType.json'
export default {
  name: 'Partners',
  data() {
    return {
      actionTab: 'Platforms',
      tabList: [
        {
          label: '平台',
          value: 'Platforms',
          iconUrl: require('../../assets/partners/Platforms.svg'),
          actionIconUrl: require('../../assets/partners/Platforms-action.svg')
        },
        {
          label: '物流',
          value: 'Operations',
          iconUrl: require('../../assets/partners/Operations.svg'),
          actionIconUrl: require('../../assets/partners/Operations-action.svg')
        },
        {
          label: '支付',
          value: 'Payments',
          iconUrl: require('../../assets/partners/Payments.svg'),
          actionIconUrl: require('../../assets/partners/Payments-action.svg')
        },
        {
          label: '专门机构',
          value: 'Agencies',
          iconUrl: require('../../assets/partners/Agencies.svg'),
          actionIconUrl: require('../../assets/partners/Agencies-action.svg')
        },
        {
          label: '增长',
          value: 'Growth',
          iconUrl: require('../../assets/partners/Growth.svg'),
          actionIconUrl: require('../../assets/partners/Growth-action.svg')
        }
      ],
      partnersAllList: [
        {
          id: 1,
          type: 'Platforms',
          link: 'https://www.shopify.com/',
          imageUrl: require('../../assets/partners/image/shopify-logo-2018.svg')
        },
        {
          id: 2,
          type: 'Platforms',
          link: 'https://www.wix.com/',
          imageUrl: require('../../assets/partners/image/WIX.svg')
        },
        {
          id: 3,
          type: 'Platforms',
          link: 'https://www.scayle.com/',
          imageUrl: require('../../assets/partners/image/scayle.svg')
        },
        {
          id: 4,
          type: 'Platforms',
          link: 'https://www.bigcommerce.com/',
          imageUrl: require('../../assets/partners/image/bigcommerce-min-1.png')
        },
        {
          id: 5,
          type: 'Platforms',
          link: 'https://www.salesforce.com/cn/?ir=1',
          imageUrl: require('../../assets/partners/image/salesforce-min-1.png')
        },
        {
          id: 6,
          type: 'Platforms',
          link: 'https://www.wix.com/',
          imageUrl: require('../../assets/partners/image/woo.svg')
        },
        {
          id: 7,
          type: 'Platforms',
          link: 'https://prestashop.com/',
          imageUrl: require('../../assets/partners/image/PREST_LOGO_RVB_noir.svg')
        },
        {
          id: 8,
          type: 'Platforms',
          link: 'https://www.shopware.com/en/',
          imageUrl: require('../../assets/partners/image/shopware_logo_blue.svg')
        },
        {
          id: 9,
          type: 'Platforms',
          link: 'https://business.adobe.com/products/magento/magento-commerce.html',
          imageUrl: require('../../assets/partners/image/magento-logo.svg')
        },
        {
          id: 10,
          type: 'Platforms',
          link: 'https://www.sap.com/index.html',
          imageUrl: require('../../assets/partners/image/saphybrislogo-002.jpg')
        },
        {
          id: 11,
          type: 'Platforms',
          link: 'https://www.visualsoft.co.uk/',
          imageUrl: require('../../assets/partners/image/visualsoft.svg')
        },
        {
          id: 12,
          type: 'Platforms',
          link: 'https://vtex.com/en-us/',
          imageUrl: require('../../assets/partners/image/6086b66465d799ab5705edec_vtex-1.svg')
        },
        {
          id: 13,
          type: 'Platforms',
          link: 'https://www.tagalys.com/',
          imageUrl: require('../../assets/partners/image/tagalys.png')
        },
        {
          id: 14,
          type: 'Platforms',
          link: 'https://www.wshop.com/',
          imageUrl: require('../../assets/partners/image/wshop.svg')
        },
        {
          id: 15,
          type: 'Platforms',
          link: 'https://commercetools.com/',
          imageUrl: require('../../assets/partners/image/commercetools-2024-logo-in-SVG-format-black-version.svg')
        },
        {
          id: 16,
          type: 'Platforms',
          link: 'https://centra.com/',
          imageUrl: require('../../assets/partners/image/svgexport-1.svg')
        },
        {
          id: 17,
          type: 'Operations',
          link: 'https://www.dhl.com/cn-zh/home.html?locale=true',
          imageUrl: require('../../assets/partners/image/DHL_logo_rgb-1024x226.png')
        },
        {
          id: 18,
          type: 'Operations',
          link: 'https://www.fedex.com.cn/',
          imageUrl: require('../../assets/partners/image/FedEx_Express.svg')
        },
        {
          id: 19,
          type: 'Operations',
          link: 'https://auspost.com.au/',
          imageUrl: require('../../assets/partners/image/AP.svg')
        },
        {
          id: 20,
          type: 'Operations',
          link: 'https://www.shipstation.com/',
          imageUrl: require('../../assets/partners/image/ShipStation-logo-black-1024x173.png')
        },
        {
          id: 21,
          type: 'Operations',
          link: 'https://www.ryder.com/en-us/e-commerce/e-commerce-fulfillment',
          imageUrl: require('../../assets/partners/image/RyderEcommerce_by_Whiplash_RGB.svg')
        },
        {
          id: 22,
          type: 'Operations',
          link: 'https://www.aramex.com/cn/en',
          imageUrl: require('../../assets/partners/image/Aramex-logo-English.webp')
        },
        {
          id: 23,
          type: 'Operations',
          link: 'https://www.pitneybowes.com/us',
          imageUrl: require('../../assets/partners/image/Pitney_Bowes_2015.svg')
        },
        {
          id: 24,
          type: 'Operations',
          link: 'http://pfscommerce.com/',
          imageUrl: require('../../assets/partners/image/PFS-Now-part-of-GXO-Logo.svg')
        },
        {
          id: 25,
          type: 'Operations',
          link: 'https://trans-cosmos.eu/',
          imageUrl: require('../../assets/partners/image/transcosmos-logo-1.svg')
        },
        {
          id: 26,
          type: 'Operations',
          link: 'https://www.flexport.com/',
          imageUrl: require('../../assets/partners/image/Flexport_logo.svg')
        },
        {
          id: 27,
          type: 'Operations',
          link: 'http://alaiko.com/',
          imageUrl: require('../../assets/partners/image/alaiko_logo_new.png')
        },
        {
          id: 28,
          type: 'Operations',
          link: 'https://www.bergenlogistics.com/',
          imageUrl: require('../../assets/partners/image/Bergen-Logistics-Logo-400x200.eps2028129.png')
        },
        {
          id: 29,
          type: 'Operations',
          link: 'https://www.bigblue.co/',
          imageUrl: require('../../assets/partners/image/bigblue.svg')
        },
        {
          id: 30,
          type: 'Operations',
          link: 'https://www.floship.com/',
          imageUrl: require('../../assets/partners/image/floship-logo-navy.png')
        },
        {
          id: 31,
          type: 'Operations',
          link: 'https://littledartfulfilment.co.uk/',
          imageUrl: require('../../assets/partners/image/Littledart-Fulfilment-Logo-High-Resolution-Transparent-Colour-1024x205.png')
        },
        {
          id: 32,
          type: 'Operations',
          link: 'https://www.moodja.com/',
          imageUrl: require('../../assets/partners/image/Moodja.svg')
        },
        {
          id: 33,
          type: 'Payments',
          link: 'https://www.paypal.com/c2/home',
          imageUrl: require('../../assets/partners/image/PayPal.svg')
        },
        {
          id: 34,
          type: 'Payments',
          link: 'https://www.klarna.com/',
          imageUrl: require('../../assets/partners/image/Klarna_Payment_Badge.svg')
        },
        {
          id: 35,
          type: 'Payments',
          link: 'https://www.forter.com/',
          imageUrl: require('../../assets/partners/image/Forter.svg')
        },
        {
          id: 36,
          type: 'Payments',
          link: 'https://www.worldpay.com/en',
          imageUrl: require('../../assets/partners/image/worldpay-from-fis-logo-vector.svg')
        },
        {
          id: 37,
          type: 'Payments',
          link: 'https://www.adyen.com/',
          imageUrl: require('../../assets/partners/image/Adyen_Corporate_Logo.svg')
        },
        {
          id: 38,
          type: 'Payments',
          link: 'https://pay.amazon.com/',
          imageUrl: require('../../assets/partners/image/amazonpay.svg')
        },
        {
          id: 39,
          type: 'Payments',
          link: 'https://stripe.com/zh-us',
          imageUrl: require('../../assets/partners/image/stripe.svg')
        },
        {
          id: 40,
          type: 'Payments',
          link: 'https://www.dlocal.com/',
          imageUrl: require('../../assets/partners/image/MDMDPFQ09QT8.png')
        },
        {
          id: 41,
          type: 'Payments',
          link: 'https://www.checkout.com/',
          imageUrl: require('../../assets/partners/image/64e79842e86ad09a621d5417_logotype-lockup.svg')
        },
        {
          id: 42,
          type: 'Agencies',
          link: 'https://astounddigital.com/',
          imageUrl: require('../../assets/partners/image/Astound.svg')
        },
        {
          id: 43,
          type: 'Agencies',
          link: 'https://www.colorz.fr/',
          imageUrl: require('../../assets/partners/image/Colorz.svg')
        },
        {
          id: 44,
          type: 'Agencies',
          link: 'https://www.barrelny.com/',
          imageUrl: require('../../assets/partners/image/Black-and-black.svg')
        },
        {
          id: 53,
          type: 'Growth',
          link: 'https://about.meta.com/',
          imageUrl: require('../../assets/partners/image/Meta_Platforms_Inc._logo.svg')
        },
        {
          id: 54,
          type: 'Growth',
          link: 'https://www.google.com/',
          imageUrl: require('../../assets/partners/image/Google.svg')
        }
      ],
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        companyName: '',
        companyWebsite: '',
        country: '',
        partnerType: ''
      },
      rules: {
        firstName: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        lastName: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        email: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        companyName: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        companyWebsite: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        country: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        partnerType: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ]
      },
      countryList: country,
      partnerTypeList: partnerType
    }
  },
  computed: {
    partnersList() {
      return this.partnersAllList.filter(item => item.type === this.actionTab)
    }
  },
  methods: {
    tabChange(item) {
      this.actionTab = item.value
    },
    onSubmit() {
      this.$refs['formDataRef'].validate(valid => {
        if (valid) {
          console.log(this.formData)
        } else {
          this.$message.warning('有必填项未填写，请填写必填字段')
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.partners {
  border-bottom: 1px solid #2a2b2f;
  .partners-head {
    padding: 0 5%;
    height: 530px;
    background: url('../../assets/partners/Screenshot-2024-10-01-125924.png')
      50% 50%;
    background-size: cover;
    .partners-head-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 150px 0;
      h1 {
        width: 350px;
        margin-bottom: 20px;
        font-size: 48px;
      }
      p {
        width: 350px;
      }
    }
  }
  .partners-tab {
    padding: 0 5%;
    background-color: #fff;
    .partners-tab-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 50px 0 80px;
      ul {
        display: flex;
        gap: 10px;
        li {
          flex: 1;
          padding: 15px 35px;
          border-bottom: 4px solid #2a2c2f1a;
          text-align: center;
          transition: all 0.5s;
          .icon {
            height: 25px;
            position: relative;
            img {
              width: 25px;
              height: 25px;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              transition: all 0.5s;
            }
            .image {
              opacity: 1;
            }
            .image-action {
              opacity: 0;
            }
          }
          h3 {
            margin-top: 15px;
            font-size: 14px;
          }
          &:hover {
            border-color: #2f5ad9;
            color: #2f5ad9;
            .image {
              opacity: 0;
            }
            .image-action {
              opacity: 1;
            }
          }
        }
        .action {
          border-color: #2f5ad9;
          color: #2f5ad9;
          .icon .image {
            opacity: 0;
          }
          .icon .image-action {
            opacity: 1;
          }
        }
      }
      .list {
        margin: 45px 0 25px;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: 50px;
        .list-item {
          height: 100px;
          border: 1px solid #2a2c2f1a;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 75%;
          }
          img[alt] {
            filter: brightness(0%) contrast(100%) saturate(100%) blur(0px)
              hue-rotate(0deg);
          }
        }
      }
    }
  }
  .partners-btn {
    padding: 0 5%;
    background-color: #fbfbfc;
    .partners-btn-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 40px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        padding: 16px 40px;
        border: 3px solid #2a2b2f;
        border-radius: 40px;
        font-size: 18px;
        font-weight: 700;
        color: #2a2b2f;
        transition: all 0.5s;
        &:hover {
          color: #2f5ad9;
          border-color: #2f5ad9;
        }
      }
    }
  }
  .partners-form {
    padding: 0 5%;
    background-color: #f5f5f6;
    .partners-form-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 100px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-form {
        width: 478px;
        padding: 35px 60px 60px;
        background-color: #fff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        h1 {
          width: 100%;
          font-size: 40px;
          margin-bottom: 20px;
        }
        .logo {
          width: 100%;
          margin-bottom: 18px;
          .logo-inner {
            width: 256px;
            height: 60px;
            box-shadow: gray 0px 0px 5px;
          }
        }
        .el-form-item {
          width: 229px;
          .btn {
            padding: 10px 40px;
            background-color: #2f5ad9;
            border-radius: 50px;
            color: #fff;
            font-size: 16px;
            font-weight: 700;
            transition: all 0.5s;
            &:hover {
              background-color: #f08f72;
            }
          }
        }
      }
    }
  }
}
</style>
